import { render, staticRenderFns } from "./ModalAddParticipant.vue?vue&type=template&id=48cdae03&scoped=true"
import script from "./ModalAddParticipant.vue?vue&type=script&lang=js"
export * from "./ModalAddParticipant.vue?vue&type=script&lang=js"
import style0 from "./ModalAddParticipant.vue?vue&type=style&index=0&id=48cdae03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cdae03",
  null
  
)

export default component.exports